import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { SharedZoneBannerBlocksBanners } from 'store/SharedZone/blocks/selectors';
import { onViewBannerBlocksBanner, onClickBannerBlocksBanner } from 'store/SharedZone/actions';
import { ViewContainer, Image, IncludeBanner } from 'bricks';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export function BannerWrapper({ href, target, className, onClick, children }) {
  return href ?
      <a href={href} target={target} onClick={onClick} className={className}>
        {children}
      </a>
    : <div role="presentation" className={className} onClick={onClick}>
        {children}
      </div>;
}

BannerWrapper.propTypes = {
  href: PropTypes.string,
  target: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.any,
};

function BannersBlockImage({
  onView,
  onClick,
  banner,
  index,
  isMobile,
  openInNewTab,
  isFullscreen,
  className,
}) {
  const payload = {
    name: banner.bannerId,
    // eslint-disable-next-line no-useless-escape
    creative: (banner.backgroundImageUrl || '').replace(/^http(s?)\:\/\/|\/\//i, ''),
    position: index + 1,
  };

  return (
    <ViewContainer
      onView={() => {
        onView(payload);
      }}
      className={cx('wrapper', isFullscreen ? 'single' : 'double', className, isMobile && 'mobile')}
    >
      {banner.bgImageUrl ?
        <IncludeBanner
          {...banner}
          {...{ isMobile }}
          className={cx('content', isMobile && 'mobile')}
          onClick={() => onClick(payload)}
        />
      : <BannerWrapper
          href={banner.url}
          onClick={() => {
            onClick(payload);
          }}
          target={openInNewTab ? '_blank' : '_self'}
        >
          {banner.backgroundImageUrl ?
            <Image
              src={banner.backgroundImageUrl}
              className={cx('image', isMobile && 'mobile')}
              alt="banner"
            />
          : banner.markup}
        </BannerWrapper>
      }
    </ViewContainer>
  );
}

BannersBlockImage.propTypes = {
  openInNewTab: PropTypes.bool,
  isFullscreen: PropTypes.bool,
  isMobile: PropTypes.bool,
  className: PropTypes.string,
  onView: PropTypes.func,
  onClick: PropTypes.func,
  banner: PropTypes.object,
  index: PropTypes.number,
};

const mapStateToProps = (state) => ({
  openInNewTab: SharedZoneBannerBlocksBanners.getOpenInNewTabFlag(state),
  isFullscreen: SharedZoneBannerBlocksBanners.getIsBannerFullscreen(state),
  banner: SharedZoneBannerBlocksBanners.getBannerData(state),
});

const mapDispatchToProps = {
  onView: onViewBannerBlocksBanner,
  onClick: onClickBannerBlocksBanner,
};

export default SharedZoneBannerBlocksBanners.connect(
  mapStateToProps,
  mapDispatchToProps,
)(BannersBlockImage);
